import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { API_URL, ENDPOINTS, postData } from '../../constants/api';
import { decodeToken, getToken } from '../../utils/TokenUtils';

export const CustomInvoice = () => {
  const [item, setItem] = useState();
  const [header, setHeader] = useState();
  const [footer, setFooter] = useState();

  const { ref_no, route } = useParams();
  const token = getToken();
  const userId = decodeToken(token, "id");
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await postData(`${API_URL}/${ENDPOINTS.SYS}/activityReport/${route}`, {
          ref_no: ref_no,
          user_id: userId
        });
        const itemData = res.data.find(d => d.title === "data")?.fields;
        setItem(itemData);
        const headerData = res.data.find(d => d.title === "header")?.fields;
        setHeader(headerData);
        const footerData = res.data.find(d => d.title === "footer")?.fields;
        setFooter(footerData);
        console.log("res.data: ", res.data);
      } catch (err) {
        console.log("Using template fallbacks for layout visualization");
      }
    };
    fetchData();
  }, [ref_no, route]);

  return (
    <>
     
    <div style={styles.wrapper}>
      <div style={styles.container}>
        <div style={styles.doubleFrameContainer}>
          
          {/* Top Corporate Branding Block */}
          <div style={styles.topBlock}>
            <div style={styles.logoWrapper}>
              <img src={`${API_URL}/${header?.logo}`} style={styles.logoImage} alt='logo' />
            </div>

            <div style={styles.metaWrapper}>
              <h1 style={styles.companyTitle}>{header?.name}</h1>
              <p style={styles.locationSub}>{header?.address}</p>
              <p style={styles.contactRow}>
               {header?.finance_tell} &nbsp;&nbsp; {header?.customer_care_tell}
              </p>
            </div>
            
          </div>
          <div style={styles.invoiceTitleWrapper}>
              <span style={styles.inlineInvoiceTitle}>INVOICE (QAANSHEEGAD)</span>
            </div>
          <div style={styles.formRow}>
            <span style={styles.labelElement}>DATE:</span>

            <div style={{ ...styles.inputUnderlineFill, flex: '0 1 180px' }}>
              <span style={styles.handwrittenInk}>{item?.date}</span>
            </div>

            <h2 style={styles.serialNo}>
            {item?.invoiceNo}
            </h2>
          </div>

          {/* Row 2: Name spanning full remaining width */}
          <div style={styles.formRow}>
            <span style={styles.labelElement}>Name:</span>
            <div style={styles.inputUnderlineFill}>
              <span style={{ ...styles.handwrittenInk, paddingLeft: '20px' }}>{item?.name}</span>
            </div>
          </div>

          {/* Row 3: Three-Column Metrics (Cabir hore, Cabir Danbe, Farqi) */}
          <div style={styles.formRow}>
            <div style={{ display: 'flex', flex: 1.1, alignItems: 'baseline' }}>
              <span style={styles.labelElement}>Cabir hore:</span>
              <div style={styles.inputUnderlineFill}>
                <span style={styles.handwrittenInk}>{item?.cabirHore}</span>
              </div>
            </div>

            <div style={{ display: 'flex', flex: 1.2, alignItems: 'baseline', paddingLeft: '15px' }}>
              <span style={styles.labelElement}>Cabir Danbe:</span>
              <div style={styles.inputUnderlineFill}>
                <span style={styles.handwrittenInk}>{item?.cabirDanbe}</span>
              </div>
            </div>

            <div style={{ display: 'flex', flex: 0.9, alignItems: 'baseline', paddingLeft: '15px' }}>
              <span style={styles.labelElement}>Farqi:</span>
              <div style={styles.inputUnderlineFill}>
                <span style={styles.handwrittenInk}>{item?.farqi}</span>
              </div>
            </div>
          </div>

          {/* Row 4: Two-Column Metrics (Sicirka, Biilka bisha) */}
          <div style={styles.formRow}>
            <div style={{ display: 'flex', flex: 1, alignItems: 'baseline' }}>
              <span style={styles.labelElement}>Sicirka:</span>
              <div style={styles.inputUnderlineFill}>
                <span style={styles.handwrittenInk}>{item?.sicirka}</span>
              </div>
            </div>

            <div style={{ display: 'flex', flex: 1, alignItems: 'baseline', paddingLeft: '25px' }}>
              <span style={styles.labelElement}>Biilka bisha:$</span>
              <div style={styles.inputUnderlineFill}>
                <span style={styles.handwrittenInk}>{item?.biilkaBisha}</span>
              </div>
            </div>
          </div>

          {/* Row 5: Totals Metrics (Haraa Hore, Wadarta Guud) */}
          <div style={styles.formRow}>
            <div style={{ display: 'flex', flex: 1, alignItems: 'baseline' }}>
              <span style={styles.labelElement}>Haraa Hore:$</span>
              <div style={styles.inputUnderlineFill}>
                <span style={styles.handwrittenInk}>{item?.haraaHore}</span>
              </div>
            </div>

            <div style={{ display: 'flex', flex: 1, alignItems: 'baseline', paddingLeft: '25px' }}>
              <span style={styles.labelElement}>Wadarta Guud:$</span>
              <div style={styles.inputUnderlineFill}>
                <span style={{ ...styles.handwrittenInk, fontWeight: 'bold' }}>{item?.wadartaGuud}</span>
              </div>
            </div>
          </div>

          {/* Banking Footer Instruction Block */}
          <div style={styles.footerInstructions}>
            <div>{footer?.payment_account1}</div>
            <div style={{ marginTop: '6px' }}>{footer?.payment_account2}</div>
          </div>
        <div style={styles.signatureArea}>
          <div style={styles.signatureBox}>
            <span style={styles.signatureLabel}>SAXIIXA:</span>
            <span style={styles.signatureLine}></span>
          </div>
        </div>

        </div>
      </div>
    </div>
    </>
  );
};

const styles = {
  
  container: {
    backgroundColor: '#fbf9f4', 
    width: '100%',
    // maxWidth: '880px',
    padding: '6px',
    boxSizing: 'border-box',
    boxShadow: '0 8px 24px rgba(0,0,0,0.12)'
  },
  // 1. Classic double-line vintage frame boundary
  doubleFrameContainer: {
    border: '6px solid #0f367a',
    padding: '4px', 
    boxSizing: 'border-box',
    width: '100%',
    // Inner border simulation using a secondary border wrapping content
    outline: '3px solid #0f367a',
    outlineOffset: '-5px',
    paddingTop: '20px',
    paddingBottom: '20px',
    paddingLeft: '30px',
    paddingRight: '30px',
    display: 'flex',
    flexDirection: 'column'
  },
  // 2. Branding layout architecture
  topBlock: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '10px',
    width: '100%'
  },
  logoWrapper: {
    width: '260px',
    height:"260px",
  
  },
  logoImage: {
    width: '100%',
    height: 'auto',
    objectFit: 'cover'
  },
  metaWrapper: {
    flex: 1,
    textAlign: 'center',
    color: '#0f367a',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    paddingRight: '40px' // balances space against the left logo offset
  },
  companyTitle: {
    fontFamily: '"Arial Black", sans-serif',
    fontSize: '34px',
    fontWeight: '900',
    margin: '0',
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    lineHeight: '1.1'
  },
  locationSub: {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'bold',
    margin: '4px 0 2px 0',
    lineHeight: '1.2',
    color:'#0f367a',
  },
  contactRow: {
    fontFamily: 'sans-serif',
    fontSize: '13px',
    fontWeight: 'bold',
    margin: '0',
    lineHeight: '1.2',
    color:'#0f367a',
  },
  
  formRow: { display: 'flex', alignItems: 'center', width: '100%', minHeight: '40px', marginTop: '12px', position: 'relative' },
  serialNo: {
  fontFamily: '"Times New Roman", Times, serif',
  color: '#d32f2f',
  fontSize: '36px',
  fontWeight: 'bold',
  margin: '0',
  lineHeight: '1',
  alignSelf: 'flex-end',
  marginLeft: 'auto', // Pushes it to the far right
},

  labelElement: {
    color: '#0f367a',
    fontFamily: 'sans-serif',
    fontSize: '17px',
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    paddingRight: '6px'
  },
  inputUnderlineFill: {
    flex: 1,
    borderBottom: '2px solid #0f367a',
    position: 'relative',
    display: 'flex',
    alignItems: 'flex-end',
    minHeight: '28px'
  },
  invoiceTitleWrapper: {
    flex: 1,
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems:'flex-start',
  },
  inlineInvoiceTitle: {
    color: '#0f367a',
    fontFamily: '"Arial Black", sans-serif',
    fontSize: '20px',
    fontWeight: '900',
    textTransform: 'uppercase',
    padding: '2px 14px',
  },
  // Real-world blue ink simulation setup
  handwrittenInk: {
    fontFamily: '"Caveat", "Comic Sans MS", cursive, sans-serif',
    color: '#1d3dc5',
    fontSize: '24px',
    fontWeight: '600',
    paddingLeft: '10px',
    position: 'absolute',
    bottom: '-2px',
    lineHeight: '1'
  },

  // 5. Instruction Footers & Signatures
  footerInstructions: {
    marginTop: '30px',
    textAlign: 'center',
    color: '#0f367a',
    fontFamily: 'sans-serif',
    fontSize: '14px',
    fontWeight: 'bold',
    lineHeight: '1.4'
  },
  signatureArea: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '20px',
    width: '100%',
  },

  signatureBox: {
    display: 'flex',
    alignItems: 'center',
    width: '320px',
    gap: '10px',
  },

  signatureLabel: {
    color: '#0f367a',
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
  },

  signatureLine: {
    flex: 1,
    marginTop:"8px",
    borderBottom: '3px solid #0f367a',
    height: '0',
  },
};